<div class="select" [ngClass]="state()" #selectField>
  <div class="select-container" (click)="onOpen()" [class.isDisabled]="disabled()">
    <span class="select-container-text">{{ displayText() || placeholder() | transloco }}</span>
    <ui-inline-svg class="select-container-icon" [name]="'tooltip-arrow-top'"></ui-inline-svg>
  </div>

  @if (isOpen() && !disabled()) {
  <ul class="select-options">
    @for (option of options(); track $index) {
    <li
      class="select-options-list"
      data-testid="select-option"
      uiTooltip
      [tooltipText]="option.description ? (option.description | transloco) : ''"
      tooltipPosition="start"
      (click)="onSelect(option)">
      {{ option.label | transloco }}
    </li>
    }
  </ul>
  }

  @if (alert() && state() !== fieldState.Default) {
    <div class="select-alert">
      <ui-inline-svg class="select-alert-icon" [name]="alertIcon()"></ui-inline-svg>
      <span class="select-alert-text">{{ alert() }}</span>
    </div>
  }
</div>
